module.exports = __webpack_public_path__ + "img/404.bd7dfe6c.png";